// ----------------------------------------------------------------------

export default function CssBaseline() {
  return {
    MuiCssBaseline: {
      styleOverrides: {
        '*': {
          margin: 0,
          padding: 0,
          boxSizing: 'border-box',
        },
        html: {
          width: '100%',
          height: '100%',
          WebkitOverflowScrolling: 'touch',
        },
        body: {
          width: '100%',
          height: '100%',
        },
        '#root': {
          width: '100%',
          height: '100%',
        },
        input: {
          '&[type=number]': {
            MozAppearance: 'textfield',
            '&::-webkit-outer-spin-button': {
              margin: 0,
              WebkitAppearance: 'none',
            },
            '&::-webkit-inner-spin-button': {
              margin: 0,
              WebkitAppearance: 'none',
            },
          },
        },
        img: {
          display: 'block',
          maxWidth: '100%',
        },
        '@media print': {
          'header, nav, aside, .MuiAppBar-root, .MuiDrawer-root, .no-print, .MuiBreadcrumbs-root, .MuiAlert-root': {
            display: 'none !important',
          },
          '#root': {
            height: 'auto !important',
            minHeight: 'auto !important',
            overflow: 'visible !important',
            width: '100% !important',
          },
          'body, html': {
            height: 'auto !important',
            overflow: 'visible !important',
            background: '#ffffff !important',
          },
        },
      },
    },
  };
}
